import { Injectable } from '@angular/core';
import { AuthService } from '../auth.service';
import { Observable } from 'rxjs';
import { IntegrationModel, IntegrationFilter } from '../../models/qrcode-integrations/integration.model';
import { IntegrationStudentGivenRewardModel } from '../../models/qrcode-integrations/integration-student-given-reward.model';
import { map } from 'rxjs/operators';
import { StringExtensionModel } from '../../models/extensions/string-extension.model';

@Injectable({
  providedIn: 'root'
})
export class AdminIntegrationService {

  constructor(private authSv: AuthService) {
  }

  /**
   * Fetch integrations with optional filtering
   */
  fetchIntegrations(filter?: IntegrationFilter): Observable<IntegrationModel[]> {

    let url = '/admin/integration-definitions';

    if (filter) {
      url += StringExtensionModel.queryString(filter);
    }

    return this.authSv.get(url).pipe(map((response) => {
      return IntegrationModel.generateModels(response.data);
    }));

  }

  /**
   * Fetch a single integration by ID
   * Can be used publicly or for super admins
   */
  fetchIntegrationById(integrationId: string): Observable<IntegrationModel> {

    return this.authSv.get(`/integration-definitions/${integrationId}`).pipe(map((response) => {
      return IntegrationModel.generateModel(response.data);
    }));

  }

  /**
   * Create or update an integration
   * If _id is provided, it will update; otherwise, it will create a new one
   */
  createOrUpdateIntegration(integration: IntegrationModel): Observable<IntegrationModel> {
    
    return this.authSv.post('/admin/integration-definitions', integration).pipe(map((response) => {
      return IntegrationModel.generateModel(response.data);
    }));

  }

  /**
   * Deletes an integration that no student has redeemed. A competition goal that used it is unlinked.
   */
  deleteIntegration(integrationId: string): Observable<any> {

    return this.authSv.delete(`/admin/integration-definitions/${integrationId}`).pipe(map((response) => {
      return response.data;
    }));

  }

  /**
   * Give integration reward to a student
   */
  giveIntegrationReward(studentId: string, integrationId: string): Observable<any> {

    return this.authSv.post(`/students/${studentId}/integration-definitions/${integrationId}/giveReward`, {}).pipe(map((response) => {
      return response.data;
    }));

  }

}

